module.exports = __webpack_public_path__ + "static/img/Logo_BEX_Neutral_Metall_RGB.75304ebc.svg";